/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, CircleSpinner, Icon } from '@components/atoms'
import { HomeSideNav, Footer } from '@components/systems'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'

import config from '@configs'
import { Decimal } from '@utils'
import { blue, grey, orange, pink, teal, yellow } from '@mui/material/colors'
import { useAppSelector, ApiGetDataStatus, HomeNavMenuType } from '@redux/index'
import { OrderType } from '@schemas'
import dayjs from 'dayjs'
import parsePhoneNumber from 'libphonenumber-js'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'

const CustomerOrderPage = () => {
	const menuList: HomeNavMenuType[] = config.customerMenu()

	const status: ApiGetDataStatus = useAppSelector(
		state => state.customerOrder.orderListStatus,
	)
	const orderList: OrderType[] = useAppSelector(state => state.customerOrder.orderList)

	const steps = [
		'Product Order Stage',
		'Parts Ordering Stage',
		'Assembly Stage',
		'Shipping Stage',
	]

	return (
		<View css={style}>
			<View className="outerView">
				<HomeSideNav menu={menuList} selectedIndes={1} />

				<View className="contentOuterView">
					<Text category="h1">My Order</Text>

					<View className="contentView">
						{status === 'init' || status === 'loading' ? (
							<View className="shippingCostSpinnerView">
								<CircleSpinner />
							</View>
						) : status === 'empty' ? (
							<View>
								<Text>No order history.</Text>
							</View>
						) : status === 'ok' ? (
							<View className="orderListView">
								{orderList.map(anOrder => {
									const address = (() => {
										let res = ''

										if (!['', 'undefined'].includes(anOrder.address1)) {
											res += anOrder.address1
										}

										if (!['', 'undefined'].includes(anOrder.address2)) {
											res += ', '
											res += anOrder.address2
										}

										if (!['', 'undefined'].includes(anOrder.city)) {
											res += ', '
											res += anOrder.city
										}

										if (!['', 'undefined'].includes(anOrder.state)) {
											res += ', '
											res += anOrder.state
										}

										if (!['', 'undefined'].includes(anOrder.country)) {
											res += ', '
											res += anOrder.country
										}

										return res
									})()

									const statusTitle =
										anOrder.status === 'new'
											? 'Paid in Full'
											: anOrder.status === 'preparing'
											? 'Preparing for transport'
											: anOrder.status === 'inTransit'
											? 'In transit'
											: anOrder.status === 'completed'
											? 'Delivery completed'
											: anOrder.status === 'deleted'
											? 'Deleted'
											: anOrder.status === 'refunded'
											? 'Refunded'
											: 'Payment completed'

									const phoneNumber = parsePhoneNumber(
										'+' + anOrder.phoneCountryNumber + anOrder.phoneNumber,
									)

									return (
										<View key={anOrder.id} className="orderItemOuterView">
											<Accordion>
												<AccordionSummary
													aria-controls={`${anOrder.id}-content`}
													id={`${anOrder.id}-header`}
													expandIcon={<Icon name="menu-down" />}
												>
													<View className="orderItemHeaderView">
														<View className={`orderStatusView ${anOrder.status}`}>
															<Text>{statusTitle}</Text>
														</View>
														<View className="orderItemTitleView">
															<Text className="orderItemTitleLabel" category="p2">
																Order No.
															</Text>
															<Text className="orderItemTitle" category="h6">
																{anOrder.id}
															</Text>
														</View>

														<View className="orderItemDatetimeView">
															<Icon name="calendar" className="orderItemDatetimeIcon" />
															<Text category="p2" className="orderItemDatetime">
																{dayjs(anOrder.createdAt).format('MMM DD YYYY')}
															</Text>

															<Icon
																name="clock-outline"
																className="orderItemDatetimeIcon"
															/>
															<Text category="p2" className="orderItemDatetime">
																{dayjs(anOrder.createdAt).format('HH:mm')}
															</Text>
														</View>

														<View className="orderProgressView">
															{/* <Stepper
																activeStep={3}
																alternativeLabel
																style={{ width: '100%' }}
															>
																{steps.map(label => (
																	<Step key={label}>
																		<StepLabel>{label}</StepLabel>
																	</Step>
																))}
															</Stepper> */}
														</View>
													</View>
												</AccordionSummary>

												<AccordionDetails>
													<View className="orderItemContentView">
														<View className="orderItemContentInnerView">
															<Text category="p1" hint="500">
																Purchase item
															</Text>
															<View className="orderItemListView">
																{anOrder.detailList.map(anItem => {
																	return (
																		<View
																			key={anItem.productId}
																			className="orderItemView"
																		>
																			<Text className="orderItemName">
																				{anItem.productName}
																			</Text>
																			<Text className="orderItemComplex" category="p2">
																				x
																			</Text>
																			<Text className="orderItemQty">
																				{anItem.quantity}
																			</Text>
																		</View>
																	)
																})}
															</View>
														</View>

														<View className="orderItemContentInnerView">
															<Text category="p1" hint="500">
																Payment information
															</Text>

															<View className="orderPaidInfoView">
																<Text category="p2">Item Price</Text>
																<Text category="p2">
																	{Decimal(anOrder.totalUsd * 1.1).toLocaleString(
																		'en-US',
																		{
																			style: 'currency',
																			currency: 'USD',
																		},
																	)}
																</Text>
															</View>
															{/* <View className="orderPaidInfoView">
																<Text category="p2">Item VAT</Text>
																<Text category="p2">
																	{(anOrder.totalUsd / 10).toLocaleString('en-US', {
																		style: 'currency',
																		currency: 'USD',
																	})}
																</Text>
															</View> */}
															<View className="orderPaidInfoView">
																<Text category="p2">Shipping Fee</Text>
																<Text category="p2">
																	{((anOrder.shippingUsd * 100) / 110).toLocaleString(
																		'en-US',
																		{
																			style: 'currency',
																			currency: 'USD',
																		},
																	)}
																</Text>
															</View>
															{/* <View className="orderPaidInfoView">
																<Text category="p2">Shipping VAT</Text>
																<Text category="p2">
																	{(anOrder.shippingUsd / 11).toLocaleString('en-US', {
																		style: 'currency',
																		currency: 'USD',
																	})}
																</Text>
															</View> */}
															<View className="orderPaidInfoView total">
																<Text>Total Paid</Text>
																<Text>
																	{anOrder.paidUsd.toLocaleString('en-US', {
																		style: 'currency',
																		currency: 'USD',
																	})}
																</Text>
															</View>
															{/* <View className="orderPaidInfoView">
																<Text category="p2">Total VAT</Text>
																<Text category="p2">
																	{anOrder.vatUsd.toLocaleString('en-US', {
																		style: 'currency',
																		currency: 'USD',
																	})}
																</Text>
															</View> */}
														</View>

														<View className="orderItemContentInnerView">
															<Text category="p1" hint="500">
																Recipient Information
															</Text>

															<View className="recipientInfoView">
																<Text category="p2" className="recipientLabel">
																	Given Name:
																</Text>
																<Text>{anOrder.receiverGivenName}</Text>
															</View>
															<View className="recipientInfoView">
																<Text category="p2" className="recipientLabel">
																	Family Name:
																</Text>
																<Text>{anOrder.receiverFamilyName}</Text>
															</View>

															<View className="recipientInfoView">
																<Text category="p2" className="recipientLabel">
																	Address:
																</Text>
																<Text>{address}</Text>
															</View>

															<View className="recipientInfoView">
																<Text category="p2" className="recipientLabel">
																	Contact Number:
																</Text>
																<Text>{phoneNumber?.formatInternational()}</Text>
																{/* <Text>{anOrder.phoneNumber}</Text> */}
															</View>
														</View>

														<View className="orderItemContentInnerView">
															<Text category="p1" hint="500">
																Shipping information
															</Text>

															<View>
																<Text category="p2">Shipping Company: </Text>
																<Text>
																	{anOrder.deliveryCompany === 'local'
																		? ''
																		: anOrder.deliveryCompany}
																</Text>
															</View>
															<View>
																<Text category="p2">Tracking No.: </Text>
																<Text>{anOrder.trackingNumber}</Text>
															</View>
														</View>
													</View>
												</AccordionDetails>
											</Accordion>

											<View></View>
										</View>
									)
								})}
							</View>
						) : null}
					</View>
				</View>
			</View>

			<Footer />
		</View>
	)
}

export default CustomerOrderPage

const style = css({
	position: 'relative',
	width: '100%',

	'.outerView': {
		display: 'flex',
		paddingTop: '2rem',
		paddingBottom: '2rem',
		borderBottom: '1px solid',
		borderColor: grey[300],

		'.contentOuterView': {
			width: 'calc(100% - 15rem)',
			minHeight: 'calc(100vh - 10rem)',
			padding: '2rem',
			borderLeft: '1px solid',
			borderColor: grey[300],

			'.contentView': {
				width: '100%',
				maxWidth: '50rem',
				right: 0,
				left: 0,
				margin: 'auto',
				paddingTop: '3rem',
				borderTop: '1px solid',
				borderColor: grey[500],

				'.orderListView': {
					'.orderItemOuterView': {
						textAlign: 'left',

						'.orderItemHeaderView': {
							width: '100%',
							boxShadow: '0',

							'.orderStatusView': {
								position: 'absolute',
								right: '3rem',
								top: '3.3rem',
								width: 'fit-content',
								padding: '0.5rem',
								borderRadius: '30px',

								'&.new': {
									backgroundColor: grey['800'],
									color: 'white',
								},

								'&.preparing': {
									backgroundColor: yellow['A400'],
									color: grey[900],
								},

								'&.inTransit': {
									backgroundColor: teal['A400'],
									color: 'white',
								},

								'&.completed': {
									backgroundColor: blue['A400'],
									color: 'white',
								},

								'&.deleted': {
									backgroundColor: pink['A400'],
									color: 'white',
								},

								'&.refunded': {
									backgroundColor: orange['A400'],
									color: 'white',
								},

								p: {
									margin: 0,
								},
							},

							'.orderItemTitleView': {
								'.orderItemTitleLabel': {},
								'.orderItemTitle': {
									margin: '0 0 1rem',
								},
							},
							'.orderItemDatetimeView': {
								display: 'flex',
								alignItems: 'center',

								'.orderItemDatetimeIcon': {
									marginRight: '0.3rem',
									color: grey['500'],
								},
								'.orderItemDatetime': {
									marginRight: '1rem',
									color: grey['500'],
								},
							},
							'.orderProgressView': {
								width: '100%',
								paddingTop: '2rem',
								paddingBottom: '2rem',
							},
						},

						'.orderItemContentView': {
							borderTop: '1px solid',
							borderColor: grey[700],

							'.orderItemContentInnerView': {
								width: '25rem',
								margin: 'auto',
								marginBottom: '2rem',

								'.orderItemListView': {
									'.orderItemView': {
										display: 'flex',
										alignItems: 'center',

										'.orderItemName': {
											margin: 0,
											marginBottom: '0.5rem',
										},
										'.orderItemComplex': {
											margin: '0 1rem 0.5rem',
										},
										'.orderItemQty': {
											margin: 0,
											marginBottom: '0.5rem',
										},
									},
								},

								'.orderPaidInfoView': {
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'space-between',
									width: '100%',

									p: {
										margin: '0.2rem 0 0.2rem',
									},

									'&.total': {
										borderTop: '1px solid',
										borderColor: grey[200],
									},
								},

								'.recipientInfoView': {
									display: 'flex',

									p: {
										margin: '0.2rem 0 0.2rem',
									},

									'.recipientLabel': {
										width: '8rem',
									},
								},
							},
						},
					},
				},
			},
		},
	},
})
